import { startsWith } from 'lodash';
import { ExternalLink } from '@msrceng/component';
import { Vulnerability } from 'types';

/**
 * UI for rendering the CVE.org link on the CVE details page's title card.
 */
export const CVEOrgLink = ({
  cveNumber,
  mitreText,
  mitreUrl,
}: Partial<Pick<Vulnerability, 'cveNumber' | 'mitreUrl' | 'mitreText'>>) => {
  if (
    !cveNumber ||
    cveNumber.length < 1 ||
    !mitreUrl ||
    mitreUrl.length < 1 ||
    startsWith(cveNumber, 'adv') ||
    startsWith(cveNumber, 'ADV')
  ) {
    return null;
  }

  return (
    <dl>
      <dt>CVE.org link</dt>
      <dd>
        <ExternalLink href={mitreUrl}>{mitreText || cveNumber}</ExternalLink>
      </dd>
    </dl>
  );
};
